@if (isOpen) {
  <div class="backdrop"></div>
  <div id="ampliar" class="modalWrapper" (click)="clickFuera($event)">
    <div id="modal" class="modalContent fadingIn">
      <div class="modal-header">
        <div class="modal-title titulo-contenidomenu">
            <ng-content select="[modal-header]"></ng-content>   
        </div>

        <div class="modal-actions">
          @if (labels) {
            <button mat-icon-button (click)="onChangeLabels()">
              <mat-icon fontSet="material-icons-outlined" [ngStyle]="{'color':'gray'}">
                {{labelsState ? 'label_off' : 'label'}}
              </mat-icon>
            </button>
          }
          @if (export) {
            <button mat-icon-button (click)="onExportFile()">
              <mat-icon [ngStyle]="{'color':'gray'}">{{iconoExport}}</mat-icon>
            </button>
          }
          @if (cerrar) {
            <button mat-icon-button (click)="onClose()">
              <mat-icon>close</mat-icon>
            </button>
          }
        </div>
      </div>

      <div class="modal-body">
        <ng-content select="[modal-body]"></ng-content>
      </div>

      <div class="modal-footer">
        <ng-content select="[modal-footer]"></ng-content>
      </div>
    </div>
  </div>
}

